import { useState } from 'react'

interface Props {
  /** El porcentaje tal como se escribe (texto): '' o '0' = sin descuento. */
  valor: string
  alCambiar: (valor: string) => void
  /** Fraccion: 0.10 = 10 %. Lo manda el motor; el tope de verdad lo impone el. */
  maximo?: number
}

/**
 * El descuento al cliente, aparte del resto del formulario y cerrado por defecto.
 *
 * Aparte a proposito: mezclado entre consumo y tarifa se rellenaba "por si acaso", y un
 * descuento es una decision comercial que tiene que verse. Cerrado, la cotizacion va sin
 * descuento salvo que alguien lo añada a conciencia.
 */
export function DescuentoCliente({ valor, alCambiar, maximo }: Props) {
  const hay = Number(valor.replace(',', '.')) > 0
  const [abierto, setAbierto] = useState(hay)
  const tope = maximo === undefined ? '' : `Máximo ${(maximo * 100).toLocaleString('es-EC')} %.`

  if (!abierto) {
    return (
      <div className="bloque-descuento">
        <button type="button" className="secundario" onClick={() => setAbierto(true)}>
          + Agregar descuento al cliente
        </button>
        <small className="ayuda">Sin descuento. {tope}</small>
      </div>
    )
  }

  return (
    <div className="bloque-descuento abierto">
      <label>
        Descuento al cliente (%)
        <input value={valor} onChange={(e) => alCambiar(e.target.value)} inputMode="decimal" autoFocus />
      </label>
      <small className="ayuda">Sobre el subtotal, antes del IVA. Queda guardado con la versión. {tope}</small>
      <button
        type="button"
        className="enlace"
        onClick={() => {
          alCambiar('0')
          setAbierto(false)
        }}
      >
        Quitar descuento
      </button>
    </div>
  )
}
